<template>
  <!-- apex chart -->
  <vue-apex-charts
    ref="donut"
    :key="'donut'"
    type="radialBar"
    :height="boxHeight >= 300 ? 240 : '70%'"
    :options="goalOverviewRadialBar"
    :series="series"
  />
</template>

<script>

import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

const $strokeColor = '#ebe9f1'
const $textHeadingColor = '#5e5873'
const $goalStrokeColor2 = '#51e5a8'

export default {
  components: {
    VueApexCharts,
  },
  props: {
    statistic: {
      type: [Number, String],
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    boxHeight: {
      type: [Number, String],
      default: 'auto',
    },
  },
  data() {
    return {
      series: [this.statistic],
    }
  },
  computed: {
    goalOverviewRadialBar() {
      return {
        chart: {
          type: 'radialBar',
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: false,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: this.boxHeight >= 300 ? '70%' : '50%',
            },
            track: {
              background: $strokeColor,
              strokeWidth: '100%',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: true,
                formatter: this.myFormatter,
                color: $textHeadingColor,
                fontSize: this.boxHeight >= 300 ? '1.8rem' : '1.3rem',
                fontWeight: '600',
                fontFamily: 'Montserrat',
                offsetY: 10,
              },
            },
          },
        },
        fill: {
          type: 'solid',
          colors: [$themeColors[this.findColor()]],
        },
        stroke: {
          lineCap: 'round',
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      }
    },

  },
  watch: {
    statistic(val) {
      this.series = [val]
    },
  },
  methods: {
    myFormatter() {
      return this.statistic
    },
    findColor() {
      if (this.color === 'dynamic') {
        if (parseFloat(this.statistic) < 26) {
          return 'danger'
        }
        if (parseFloat(this.statistic) < 51) {
          return 'warning'
        }
        if (parseFloat(this.statistic) < 71) {
          return 'info'
        }

        return 'success'
      }
      return this.color
    },
  },
}
</script>
